import { render, staticRenderFns } from "./veStuLiteraryProgramShow.vue?vue&type=template&id=38dd8a3a&scoped=true"
import script from "./veStuLiteraryProgramShow.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryProgramShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd8a3a",
  null
  
)

export default component.exports